import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/css/base.css';
import './plugins/element.js';
import './theme/global.scss';
import { prompt } from './components/layout/prompt';
import format from './config/format';
Vue.use(format);
Vue.config.productionTip = false;
Vue.prototype.$prompt = prompt;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
